import { useState } from "react";
import BaseCollection from "@sourceflow-uk/sourceflow-sdk/base_collection";

export default function useSourceFlowCollection(data) {
  const [items] = useState(new BaseCollection(data, "en").getItems());

  return items;
}
